import { Env } from "@constants/env";
import { REG_EXP } from "@constants/regexp";

import { types } from "mobx-state-tree";

export const StorageConfigsModel = types
  .model({
    configs: types.optional(
      types.model({
        serverPath: types.string,
      }),
      { serverPath: Env.REACT_APP_CLIENT_SERVER_PATH || "" }
    ),
  })
  .actions((self) => ({
    setServerPath: (domain: string): void => {
      if (!REG_EXP.DOOK_WEB_URL.test(domain)) {
        throw new Error();
      }

      // if (!await fetch(`${domain}/`))

      self.configs.serverPath = domain;
    },
  }));
